module.exports = __webpack_public_path__ + "mainassets/img/gallery-arrow-left.15d6c90c.svg";